import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { form } from "../../../shared/src/codecs/types/form";
import { required } from "../../../shared/src/codecs/types/required";
import { array } from "../../../shared/src/codecs/types/array";
import { string } from "../../../shared/src/codecs/types/string";
import { union } from "../../../shared/src/codecs/types/union";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { CaseId } from "../CaseId";
import { EmptyObject } from "../EmptyObject";
import {
    ManagementCompany,
    CasesManagementCompanyLink,
    ManagementCompanyFormType,
} from "../ManagementCompany";

export const ManagementCompanySearchForm =
    form(
        required({
            case_id: uuid(),
            search_string: string(),
        }),
        array(ManagementCompany),
    );
export type TManagementCompanySearchFormCodec = typeof ManagementCompanySearchForm;
export type TManagementCompanySearchForm = TTypeOfCodec<TManagementCompanySearchFormCodec>;

export const CreateCaseManagementCompanyForm =
    form(
        required({
            case_id: uuid(),
            management_company_id: union([uuid(), nullCodec()]),
            new_company_name: string(),
            form_type: union([ManagementCompanyFormType, nullCodec()]),
        }),
        EmptyObject,
    );
export type TCreateCaseManagementCompanyFormCodec = typeof CreateCaseManagementCompanyForm;
export type TCreateCaseManagementCompanyForm = TTypeOfCodec<TCreateCaseManagementCompanyFormCodec>;

export const CaseManagementCompanyForm =
    form(
        required({
            link: CasesManagementCompanyLink,
            company: ManagementCompany,
        }),
        EmptyObject,
    );
export type TCaseManagementCompanyFormCodec = typeof CaseManagementCompanyForm;
export type TCaseManagementCompanyForm = TTypeOfCodec<TCaseManagementCompanyFormCodec>;

export const CaseManagementCompaniesForm =
    form(
        CaseId,
        required({
            items: array(CaseManagementCompanyForm),
            create: CreateCaseManagementCompanyForm,
            search: ManagementCompanySearchForm,
        }),
    );
export type TCaseManagementCompaniesFormCodec = typeof CaseManagementCompaniesForm;
export type TCaseManagementCompaniesForm = TTypeOfCodec<TCaseManagementCompaniesFormCodec>;
